export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"
export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

// OTP Actions
export const OTP_GENERATE_SUCCESS = "OTP_GENERATE_SUCCESS"
export const OTP_VERIFY_SUCCESS = "OTP_VERIFY_SUCCESS"
export const OTP_ACTION_ERROR = "OTP_ACTION_ERROR"
export const CLEAR_LOGIN_MESSAGE = "CLEAR_LOGIN_MESSAGE"